/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const upsertFeatureFlagBodySchema = z.object({
  value: z.string(),
  enabled: z.boolean(),
});

export type IUpsertFeatureFlagBody = z.infer<typeof upsertFeatureFlagBodySchema>;
